/**
 * The single confirmation-gated reminder reward. One coupon replaces the old
 * REMINDME30 path (Stripe allows only one coupon per checkout, so the reward
 * cannot stack). Shared so the seeder, the confirm route, the email, the
 * modal copy, and the landing page all read one source of truth.
 *
 * If the magnitude changes, rename the code to match the percent (the repo
 * convention: REMINDME30 / CONFIRM40 / CLARA30).
 */
export const REMINDER_REWARD_CODE = "REMIND35";
export const REMINDER_REWARD_PERCENT = 35;
